/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import InViewComponent from '../../../shared/components/inView/inView';

const SectionComponent = props => {
    const [inViewBanner, setInViewBanner] = useState(false);

    useEffect(() => {
        handleAnimation();
    }, [inViewBanner]);

    const handleAnimation = () => {
        const textHeading = document.getElementsByClassName("slide-left")[props.index];
        const svgIllustrated = document.getElementsByClassName("slide-right")[props.index];
        const cardlist = document.getElementsByClassName("cardlist")[props.index];
        let featureList = null;
        if (props.id === "#payment-gateway") {
            featureList = document.getElementsByClassName("feature-section-block");
        }
        if (textHeading && svgIllustrated && cardlist) {
            if (inViewBanner) {
                textHeading.classList.add("is-animate");
                svgIllustrated.classList.add("is-animate");
                for (let i = 0; i < cardlist.childNodes.length; i++) {
                    setTimeout(() => {
                        cardlist.childNodes[i].childNodes[0].classList.add("is-animate");
                    }, i * 350);
                }
                if (featureList) {
                    for (let i =0; i < featureList.length; ++i) {
                        setTimeout(() => {
                            featureList[i].classList.add("is-animate");
                        }, (cardlist.childNodes.length + i) * 350);
                    }
                }
            } else {
                textHeading.classList.remove("is-animate");
                svgIllustrated.classList.remove("is-animate");
                cardlist.childNodes.forEach((obj, index) => {
                    // setTimeout(() => {
                    obj.childNodes[0].classList.remove("is-animate");
                    // }, index * 250);
                });
                if (featureList) {
                    for (let feature of featureList) {
                        feature.classList.remove("is-animate");
                    }
                }
            }
        }
    };
    return (
        <InViewComponent setInview={ (value) => {
            setInViewBanner(value);
        } } className="productRow" key={ props.index }>
            <div className="row-wrap mx-0" id={ props.id }>
                { props.children }
            </div>
        </InViewComponent>
    );
};

export default SectionComponent;